export const paginationConfig = { page: 1, perPage: 20 };

export const membersRoleOptions = [
  { role: "Admin", value: "Admin" },
  { role: "Owner", value: "Owner" },
  { role: "Member", value: "Member" },
  { role: "Guest", value: "Guest" },
];

export const restrictedIntegrations = ["zoom_info", "easyleadz"];

export const crmList = ["zoho", "hubspot", "salesforce"];

export const enrichmentModeRequirements = [
  {
    name: "Phone",
    value: "Phone",
    payload: ["mobile_phone"],
    autoVerify: ["mobile_phone"],
  },
  {
    name: "Email",
    value: "Email",
    payload: ["work_email", "personal_email"],
    autoVerify: ["work_email"],
  },
  {
    name: "Email and Phone",
    value: "Email and Phone",
    payload: ["work_email", "personal_email", "mobile_phone"],
    autoVerify: ["work_email", "mobile_phone"],
  },
  {
    name: "Email or Phone",
    value: "Email or Phone",
    payload: [],
    autoVerify: [],
  },
];

export const getEnrichmentRequirementByValue = (value) => {
  const match = enrichmentModeRequirements.find((item) => item.value === value);
  return match ? match.payload : [];
};
export const getAutoVerifyByValueForEnrichmentMode = (checked, value) => {
  if (!checked) {
    return null;
  }
  const match = enrichmentModeRequirements.find((item) => item.value === value);
  return match ? match.autoVerify : [];
};

export const getEnrichmentValueByRequirement = (value = []) => {
  if (!Array.isArray(value)) {
    return "";
  }

  const hasEmail = value.some((item) => typeof item === "string" && item.includes("_email"));
  const hasPhone = value.some((item) => typeof item === "string" && item.includes("_phone"));

  if (hasEmail && hasPhone) {
    return "Email and Phone";
  }
  if (hasEmail) {
    return "Email";
  }
  if (hasPhone) {
    return "Phone";
  }
  if (value.length === 0) {
    return "Email or Phone";
  }

  return "";
};

export const apiEnv = "beta";
export const PrimeRoleExtensionId = "apmpmgboppbdhablobiakpihpppnbhcf";
export const ProspectoExtensionId = "loibhjnpccikljgheckfedilelifacgi";
export const getExtensionId = () => {
  return process.env.REACT_APP_APP_NAME === "PrimeRole" ? PrimeRoleExtensionId : ProspectoExtensionId;
};